import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CommentsState, PendingComment } from '../reducers/types';

const commentsSlice = createSlice({
  name: 'comments',
  initialState: { byPr: {} } as CommentsState,
  reducers: {
    addPrComment(
      state,
      action: PayloadAction<{ prNumber: number; comment: PendingComment }>,
    ) {
      const key = String(action.payload.prNumber);
      if (!state.byPr[key]) state.byPr[key] = [];
      state.byPr[key].push(action.payload.comment);
    },
    removePrComment(
      state,
      action: PayloadAction<{ prNumber: number; index: number }>,
    ) {
      const key = String(action.payload.prNumber);
      const arr = state.byPr[key];
      if (!arr) return;
      arr.splice(action.payload.index, 1);
      if (arr.length === 0) delete state.byPr[key];
    },
    updatePrComment(
      state,
      action: PayloadAction<{
        prNumber: number;
        anchorId: string;
        rawBody: string;
        formattedBody: string;
      }>,
    ) {
      const key = String(action.payload.prNumber);
      const arr = state.byPr[key];
      if (!arr) return;
      const item = arr.find((c) => c.anchorId === action.payload.anchorId);
      if (item?.anchorData) {
        item.body = action.payload.formattedBody;
        item.anchorData.rawBody = action.payload.rawBody;
      }
    },
    clearPrComments(state, action: PayloadAction<{ prNumber: number }>) {
      delete state.byPr[String(action.payload.prNumber)];
    },
  },
});

export const {
  addPrComment,
  removePrComment,
  updatePrComment,
  clearPrComments,
} = commentsSlice.actions;
export default commentsSlice.reducer;
